import React from 'react';
import styles from '../../s.module.less';

const RightPanel: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
    <div className={styles.rightPanel}>
        {children}
    </div>
);

export default RightPanel;
